import { render, staticRenderFns } from "./customsInfoResFileHistoryDialog.vue?vue&type=template&id=4c6b91c1&scoped=true&"
import script from "./customsInfoResFileHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./customsInfoResFileHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./customsInfoResFileHistoryDialog.vue?vue&type=style&index=0&id=4c6b91c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b91c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6b91c1')) {
      api.createRecord('4c6b91c1', component.options)
    } else {
      api.reload('4c6b91c1', component.options)
    }
    module.hot.accept("./customsInfoResFileHistoryDialog.vue?vue&type=template&id=4c6b91c1&scoped=true&", function () {
      api.rerender('4c6b91c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/FileUpload/customsInfoResFileHistoryDialog.vue"
export default component.exports